<template>
  <div>
    <Head title="Lage & Ausstattung" />
    <section class="py-3 lg:px-16">
      <h2>Lage</h2>
      <p>Unsere Ferienwohnung liegt direkt an einem Wald in sehr ruhiger Lage.</p>
      <p>Adresse: Bergstraße 16 in 03096 Guhrow</p>
      <div class="py-3">
        <a href="https://goo.gl/maps/3rZkuqN4iGL7SReL6" target="_blank"><img class="rounded-lg shadow-md shadow-gray-500" src="https://api.mapbox.com/styles/v1/mapbox/outdoors-v11/static/url-https%3A%2F%2Feu2.contabostorage.com%2F8dc3fff3f5804872aa520d5850ddd29a%3Afewovs-s3-media%2Ficon_map_marker.png(14.226,51.833)/14.1625,51.7912,10.44,0/900x600@2x?access_token=pk.eyJ1IjoiemVhY29tIiwiYSI6ImNsZDIzOTN4ZjA0cmQzdm8weDV0NDY1N3IifQ.pxbHCrmNDQSUt6lHVg6DnQ" /></a>
      </div>
      <p>Guhrow liegt in der Niederlausitz, unmittelbar am östlichen Rand des Spreewaldes. Im Ort befinden sich ein Bäcker und ein sehr gut ausgebautes Radwegenetz, welches fast direkt vor der Tür startet. Auf dem Spreedamm ist man schnell direkt nach Burg oder Cottbus geradelt. Die Lage ist optimal für Ausflüge oder einfach nur ein paar schöne Stunden an der Spree.</p>
    </section>
    <section class="py-3 lg:px-16">
      <h2>Umgebung</h2>
      <p>Das Stadtzentrum von Cottbus liegt ca. 11 Kilometer von Guhrow entfernt. Dort gibt es einen schönen Tierpark mit Parkeisenbahn, ein Theater und ein Piccolo Theater, den Fürst Pückler- und Spreeauenpark und zwei Kinos.</p>
      <p>Im Kurort Burg (Spreewald), welcher ca. 9 Kilometer entfernt ist, gibt es zahlreiche Angebote an Kahn- und Paddeltouren, touristische Sehenswürdigkeiten, eine Therme, Gaststätten und Einkaufsmöglichkeiten.</p>
      <p>Ausflugsziele die wir noch empfehlen können sind:</p>
      <div class="relative overflow-x-auto my-3">
        <table class="w-full text-sm text-left">
          <thead class="text-xs text-gray-700 uppercase">
            <tr>
              <th scope="col" class="lg:px-6 py-3">Ausflugsziel</th>
              <th scope="col" class="lg:px-6 py-3">Entfernung</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in excursions" class="border-b">
              <td class="lg:px-6 py-4">{{ item.destination }}</td>
              <td class="lg:px-6 py-4">{{ item.distance }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

import 'vue-silentbox/dist/style.css'

export default {
  components: {
    Head,
  },
  layout: Layout,

  data() {
    return {
      excursions: [
        {
          destination: 'das Besucherbergwerk F60',
          distance: 'ca. 49 km',
        },
        {
          destination: 'Bad Muskau (Polenmarkt)',
          distance: 'ca. 53 km',
        },
        {
          destination: 'Erlebnispark Teichland',
          distance: 'ca. 19 km',
        },
        {
          destination: 'Tropical Island ',
          distance: 'ca. 58 km',
        },
      ],
      lightboxList: [],
      lightboxIndex: 0,
    }
  },
}
</script>